import React from 'react';
import { motion } from 'framer-motion';
import { CalendarDaysIcon, CalendarPlusIcon, UsersIcon } from 'lucide-react';
import { Button } from './Button';
import { Reveal } from './Reveal';
import { election } from '../data/election';
import { openExternal, scrollToSection } from '../utils/navigation';
export function ClosingSection() {
  return <section aria-labelledby="cierre-title" className="relative overflow-hidden bg-primary" data-id="element-220" data-mp="xsfppzkvzabk">
      <motion.img src={election.closingImage} alt="" aria-hidden initial={{
      scale: 1.1
    }} whileInView={{
      scale: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 2,
      ease: 'easeOut'
    }} className="absolute inset-0 h-full w-full object-cover" data-id="element-221" data-mp="1cpghg332v5a1" />
      <div aria-hidden className="absolute inset-0 bg-[#0E2160]/80" data-id="element-222" data-mp="1hjuhwjwlk2lk" />

      <div className="relative mx-auto grid max-w-7xl items-center gap-12 px-6 py-16 md:py-20 lg:grid-cols-[1.2fr_1fr]" data-id="element-223" data-mp="1viamo5awfj12">
        <Reveal data-id="element-224" data-mp="1qgbl90ypyw6r">
          <h2 id="cierre-title" className="type-h2 text-white" data-id="element-225" data-mp="22cc84rgy1534">
            Tu voto cuenta
          </h2>
          <p className="mt-5 max-w-lg text-lg leading-relaxed text-white/80" data-id="element-226" data-mp="27bfgolw4ttfu">
            Por una Cámara de Comercio con más empresa y más región. Creemos en la responsabilidad, la articulación y la innovación.
          </p>
          <div className="mt-10 flex flex-wrap gap-4" data-id="element-227" data-mp="2gcdkp46km0yf">
            <Button variant="secondary" size="lg" leftIcon={<UsersIcon className="h-4 w-4" data-id="element-229" data-mp="2lbzv75v0l33j" />} onClick={() => scrollToSection('lista')} data-id="element-228" data-mp="2g9sfq6az74wg">
              Conoce la lista
            </Button>
            <button type="button" onClick={() => openExternal(election.calendarUrl)} className="inline-flex items-center gap-2 rounded-full border border-white/40 px-6 py-3 text-sm font-semibold text-white transition hover:border-white hover:bg-white hover:text-primary focus:outline-none focus-visible:ring-2 focus-visible:ring-accent-gold" data-id="element-230" data-mp="2q8gixyyaxfg3">
              <CalendarPlusIcon className="h-4 w-4" data-id="element-231" data-mp="3912gqosrrg3b" />
              Agéndalo
            </button>
          </div>
        </Reveal>

        <Reveal delay={0.15} data-id="element-232" data-mp="14wxzzh54w7z7">
          <motion.div whileHover={{
          rotate: -1,
          scale: 1.02
        }} transition={{
          type: 'spring',
          stiffness: 250,
          damping: 18
        }} className="mx-auto max-w-sm overflow-hidden rounded-[32px] bg-white shadow-lg" data-id="element-233" data-mp="14xzexwp9tem7">
            <div className="flex items-center justify-between gap-4 bg-accent-gold px-8 py-7" data-id="element-234" data-mp="1dvt7cwjwzo43">
              <div className="font-display font-extrabold uppercase" data-id="element-235" data-mp="1sod9puz8prkh">
                <p className="text-[52px] leading-[0.85] tracking-tight text-white" data-id="element-236" data-mp="1nmxn3yhezczz">Vota</p>
                <p className="text-[40px] leading-[0.85] tracking-tight text-primary" data-id="element-237" data-mp="21lxehdwba5zu">Lista No.</p>
              </div>
              <p className="font-display text-[130px] font-extrabold leading-[0.7] text-primary" data-id="element-238" data-mp="1wox3qpoiof2e">{election.listNumber}</p>
            </div>
            <div className="flex items-center gap-3 px-8 py-5" data-id="element-239" data-mp="2acq2wym5jsi">
              <CalendarDaysIcon className="h-6 w-6 text-secondary-maroon" data-id="element-240" data-mp="2c7bsdhplfxn" />
              <p className="text-sm font-bold text-secondary-maroon" data-id="element-241" data-mp="2dyre2d065udj">{election.dateLabel}</p>
            </div>
          </motion.div>
        </Reveal>
      </div>

      <Reveal className="relative border-t border-white/15" data-id="element-242" data-mp="255eckmo1hkfu">
        <p className="font-display mx-auto max-w-7xl px-6 py-10 text-center text-4xl font-extrabold leading-tight text-accent-gold sm:text-5xl md:py-12 lg:text-7xl" data-id="element-243" data-mp="2531vebq3ve3u">
          ¡Llegamos, aportamos, continuamos...!
        </p>
      </Reveal>
    </section>;
}